import { useMonitor } from "@suse-o11y/signal";
import React from "react";

import { useTimestampCursorState } from "../../TimestampCursor";
import { useTimelineContext } from "../_context";

import { TimelineMarker } from "./TimelineMarker";

export const TimelineGlobalCursor: React.FC = () => {
	const monitor = useMonitor();
	const { timestampCursor } = useTimelineContext();
	const timestamp = timestampCursor.read(monitor);
	const timestampCursorState = useTimestampCursorState();

	if (timestamp == null) {
		return null;
	}

	return (
		<TimelineMarker
			dashed
			theme={timestampCursorState.isHotkeyPressed(monitor) ? "purple" : "default"}
			timestamp={timestamp}
		/>
	);
};
